import React, { useState, useEffect, useMemo, useRef, useCallback } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import redirectURL from "../redirectURL";
import { FaInfoCircle } from "react-icons/fa";
import { MdOutlineFileUpload } from "react-icons/md";
import { utils, writeFile } from "xlsx";
import * as XLSX from "xlsx";
import "./datepicker.css"

// Date helper function
const formatDateForInput = (date) => {
    if (!date) return '';
    const d = new Date(date);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

const todayIST = () => new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });

const WarehouseStockStatus = () => {
    const [loadshow, setLoadshow] = useState("show-n");
    const [overlayBlock, setOverlayBlock] = useState("show-n");
    const [overlyBlock, setOverlyBlock] = useState("show-n");
    const [show, setShow] = useState(false);
    const [basicTitle, setBasicTitle] = useState("");
    const [basicType, setBasicType] = useState("default");
    const [rowData, setRowData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [highlightedDates, setHighlightedDates] = useState([]);


    // Upload states
    const [isSliderOpen, setSliderOpen] = useState(false);
    const [sliderTitle, setSliderTitle] = useState("");
    const [uploadedFileData, setUploadedFileData] = useState([]);
    const [file, setFile] = useState(null);
    const [uploadWarehouse, setUploadWarehouse] = useState(null);
    const [uploadWarehouseOptions, setUploadWarehouseOptions] = useState([]);
    const [uploadDate, setUploadDate] = useState(() => todayIST());
    const [filename, setFilename] = useState("");
    const [confirmPopup, setConfirmPopup] = useState(false);

    // Filter states
    const [date, setDate] = useState("");
    const [warehouse, setWarehouse] = useState({ label: "ALL", value: "" });
    const [warehouseOptions, setWarehouseOptions] = useState([{ label: "ALL", value: "" }]);
    const [latestDate, setLatestDate] = useState("");

    const gridApi = useRef(null);
    const gridColumnApi = useRef(null);

    // Custom Header Component
    const CustomHeader = (props) => {
        const tooltip = props?.column?.getColDef()?.headerTooltip || "";
        const [showMenu, setShowMenu] = useState(false);
        const [showTooltip, setShowTooltip] = useState(false);

        const onMenuClick = (event) => {
            props.showColumnMenu(event.currentTarget);
        };

        const onSortRequested = (order, event) => {
            props.setSort(order, event?.shiftKey);
        };

        const getSort = () => {
            return props.column.getSort();
        };

        const isSortable = props.column.getColDef().sortable;

        return (
            <div
                style={{ display: "flex", alignItems: "center", gap: 6, position: "relative" }}
                onMouseEnter={() => setShowMenu(true)}
                onMouseLeave={() => setShowMenu(false)}
            >
                <span
                    style={{
                        cursor: isSortable ? "pointer" : "default",
                        userSelect: "none"
                    }}
                    onClick={isSortable ? () => {
                        const currentSort = getSort();
                        let newSort = 'asc';
                        if (currentSort === 'asc') newSort = 'desc';
                        else if (currentSort === 'desc') newSort = null;
                        onSortRequested(newSort, null);
                    } : undefined}
                >
                    {props.displayName}
                </span>

                {isSortable && (
                    <div style={{ display: "flex", flexDirection: "column", marginRight: 2 }}>
                        <span
                            style={{
                                cursor: "pointer",
                                fontSize: 10,
                                opacity: getSort() === 'asc' ? 1 : 0.3,
                                lineHeight: "8px"
                            }}
                            onClick={() => onSortRequested('asc', null)}
                        >
                            ↑
                        </span>
                        <span
                            style={{
                                cursor: "pointer",
                                fontSize: 10,
                                opacity: getSort() === 'desc' ? 1 : 0.3,
                                lineHeight: "8px"
                            }}
                            onClick={() => onSortRequested('desc', null)}
                        >
                            ↓
                        </span>
                    </div>
                )}

                <div
                    style={{ position: "relative", display: "inline-block" }}
                    onMouseEnter={() => setShowTooltip(true)}
                    onMouseLeave={() => setShowTooltip(false)}
                >
                    <FaInfoCircle style={{ fontSize: 18, opacity: 0.7 }} />

                    {showTooltip && tooltip && (
                        <div
                            style={{
                                position: "absolute",
                                top: "100%",
                                left: "50%",
                                transform: "translateX(-50%)",
                                backgroundColor: "rgba(0, 0, 0, 0.8)",
                                color: "white",
                                padding: "8px 12px",
                                borderRadius: "4px",
                                fontSize: "12px",
                                whiteSpace: "nowrap",
                                zIndex: 1000,
                                marginTop: "5px",
                            }}
                        >
                            {tooltip}
                        </div>
                    )}
                </div>

                {props.enableMenu && (
                    <span
                        onClick={onMenuClick}
                        style={{
                            marginLeft: "5px",
                            cursor: "pointer",
                            fontSize: 14,
                            opacity: showMenu ? 1 : 0,
                            transition: "opacity 0.2s ease",
                        }}
                    >
                        ☰
                    </span>
                )}
            </div>
        );
    };

    // Column Definitions
    const columnWithDefs = [
        {
            headerName: "Warehouse ID",
            field: "warehouse_id",
            sortable: true,
            resizable: true,
            width: 130,
        },
        {
            headerName: "Warehouse Name",
            field: "warehouse_name",
            sortable: true,
            resizable: true,
            width: 150,
        },
        {
            headerName: "SKU Code",
            field: "sku_code",
            sortable: true,
            resizable: true,
            width: 120,
        },
        {
            headerName: "Type",
            field: "type",
            sortable: true,
            resizable: true,
            width: 100,
        },
        {
            headerName: "Category",
            field: "category",
            sortable: true,
            resizable: true,
            width: 120,
        },
        {
            headerName: "SKU Name",
            field: "sku_name",
            sortable: true,
            resizable: true,
            width: 200,
        },
        {
            headerName: "Sub Category",
            field: "sub_category",
            sortable: true,
            resizable: true,
            width: 150,
        },
        {
            headerName: "Bad Bin",
            field: "bad_bin",
            sortable: true,
            resizable: true,
            width: 100,
            valueFormatter: (params) => {
                return params.value;
            }
        },
        {
            headerName: "Old Version",
            field: "old_version",
            sortable: true,
            resizable: true,
            width: 120,
            valueFormatter: (params) => {
                return params.value;
            }
        },
        {
            headerName: "QC Hold",
            field: "qc_hold",
            sortable: true,
            resizable: true,
            width: 100,
            valueFormatter: (params) => {
                return params.value;
            }
        },
        {
            headerName: "Current Version",
            field: "current_version",
            sortable: true,
            resizable: true,
            width: 140,
            valueFormatter: (params) => {
                return params.value;
            }
        },
        {
            headerName: "Date",
            field: "date",
            sortable: true,
            resizable: true,
            hide: true,
            width: 120,
            valueFormatter: (params) => {
                if (params.value) {
                    return new Date(params.value).toLocaleDateString();
                }
                return '';
            }
        }
    ];

    const sideBar = useMemo(() => ({
        toolPanels: [
            {
                id: "columns",
                labelDefault: "Columns",
                labelKey: "columns",
                iconKey: "columns",
                toolPanel: "agColumnsToolPanel",
            },
            {
                id: "filters",
                labelDefault: "Filters",
                labelKey: "filters",
                iconKey: "filter",
                toolPanel: "agFiltersToolPanel",
            },
        ]
    }), []);

    const statusPanel = {
        statusPanels: [
            {
                statusPanel: "agTotalAndFilteredRowCountComponent",
                align: "left"
            },
            {
                statusPanel: "agTotalRowCountComponent",
                align: "center"
            },
            { statusPanel: "agFilteredRowCountComponent" },
            { statusPanel: "agSelectedRowCountComponent" },
            { statusPanel: "agAggregationComponent" }
        ]
    };

    const defaultColDef = {
        sortable: true,
        filter: true,
        resizable: true,
        minWidth: 100,
    };

    const onGridReady = (params) => {
        gridApi.current = params.api;
        gridColumnApi.current = params.columnApi;

        setTimeout(() => {
            if (gridApi.current) {
                gridApi.current.sizeColumnsToFit();
            }
        }, 100);
    };

    // Get Warehouse Stock Data
    const getWarehouseStockData = async () => {
        try {
            setLoadshow("show-m");
            setOverlayBlock("show-m");
            
            const dateResponse = await redirectURL.post("inventory/getLatestStockDate", {});
            
            if (dateResponse.status === 200 && dateResponse.data.data) {
                const latestDate = new Date(dateResponse.data.data).toISOString().split('T')[0];
                setLatestDate(latestDate);
                setDate(latestDate);

                await getWarehouseOptionsByDate(latestDate);
                await loadDataForDate(latestDate, "");
                await getHighlightedDates();
            } else {
                setBasicTitle("No warehouse stock data found");
                setBasicType("info");
                setShow(true);
            }
            
            setLoadshow("show-n");
            setOverlayBlock("show-n");
        } catch (error) {
            console.error("Error fetching warehouse stock data:", error);
            setBasicTitle("Failed to fetch warehouse stock data");
            setBasicType("error");
            setShow(true);
            setLoadshow("show-n");
            setOverlayBlock("show-n");
        }
    };
      const getHighlightedDates = async () => {
        try {
            const response = await redirectURL.post("inventory/getWHAvailableDates", {});
            if (response.status === 200 && response.data.dates) {
            const dates = response.data.dates.map(dateStr => {
                try {
                return new Date(dateStr);
                } catch (e) {
                return null;
                }
            }).filter(date => date !== null);
            setHighlightedDates(dates);
            }
        } catch (error) {
            console.error("Failed to fetch highlighted dates:", error);
        }
        }
    const loadDataForDate = async (selectedDate, warehouseName = "") => {
        try {
            const params = {
                date: selectedDate || "",
                warehouse_name: warehouseName
            };

            const response = await redirectURL.post("inventory/getPmWarehouseCurrentStock", params);

            if (response.status === 200) {
                if (response.data.data && response.data.data.length > 0) {
                    setFilteredData(response.data.data);
                    
                    setTimeout(() => {
                        if (gridApi.current) {
                            gridApi.current.sizeColumnsToFit();
                        }
                    }, 100);
                } else {
                    setFilteredData([]);
                    setBasicTitle("No data found for the selected filters");
                    setBasicType("info");
                    setShow(true);
                }
            }
        } catch (error) {
            console.error("Error loading data for date:", error);
            setFilteredData([]);
            setBasicTitle("Failed to load data");
            setBasicType("error");
            setShow(true);
        }
    };

    const getWarehouseOptionsByDate = async (selectedDate) => {
        try {
            if (!selectedDate) {
                setWarehouseOptions([{ label: "ALL", value: "" }]);
                return;
            }

            const response = await redirectURL.post("inventory/getWarehousesByDate", {
                date: selectedDate
            });

            if (response.status === 200 && response.data.data) {
                const warehouses = response.data.data;
                const options = [
                    { label: "ALL", value: "" },
                    ...warehouses.map(wh => ({
                        value: wh.warehouse_name,
                        label: `${wh.warehouse_id} - ${wh.warehouse_name}`
                    }))
                ];
                setWarehouseOptions(options);
                setWarehouse(options[0]);
            }
        } catch (error) {
            console.error("Error fetching warehouse options:", error);
            setWarehouseOptions([{ label: "ALL", value: "" }]);
        }
    };

    // const getUploadWarehouseOptions = async () => {
    //     try {
    //         const response = await redirectURL.post("inventory/getPmWarehouseMaster", {});
            
    //         if (response.status === 200 && response.data.data) {
    //             const warehouses = response.data.data;
    //             const options = warehouses.map(wh => ({
    //                 value: wh.warehouse_name,
    //                 label: `${wh.warehouse_name}`
    //             }));
    //             setUploadWarehouseOptions(options);
    //         }
    //     } catch (error) {
    //         console.error("Error fetching warehouse master data:", error);
    //         setUploadWarehouseOptions([]);
    //     }
    // };
    // Get Warehouse Options for Upload
const getUploadWarehouseOptions = async () => {
    try {
        const response = await redirectURL.post("inventory/getPmWarehouseMaster", {});
        
        if (response.status === 200 && response.data.data) {
            const warehouses = response.data.data;
            
            // Define allowed warehouse names (case-insensitive)
            const allowedWarehouses = ["bhiwandi", "bangalore", "gurgaon"];
            
            // Filter warehouses
            const filteredWarehouses = warehouses.filter(wh => {
                const warehouseNameLower = wh.warehouse_name.toLowerCase();
                return allowedWarehouses.some(allowed => 
                    warehouseNameLower.includes(allowed.toLowerCase())
                );
            });
            
            const options = filteredWarehouses.map(wh => ({
                value: wh.warehouse_name,
                label: `${wh.warehouse_name}`
            }));
            
            console.log("Filtered warehouse options:", options); // For debugging
            setUploadWarehouseOptions(options);
        }
    } catch (error) {
        console.error("Error fetching warehouse master data:", error);
        setUploadWarehouseOptions([]);
    }
};

    const applyFilters = async () => {
        setLoadshow("show-m");
        setOverlayBlock("show-m");

        try {
            await loadDataForDate(date, warehouse.value);
        } catch (error) {
            console.error("Error applying filters:", error);
            setBasicTitle("Failed to apply filters");
            setBasicType("error");
            setShow(true);
        } finally {
            setLoadshow("show-n");
            setOverlayBlock("show-n");
        }
    };

    const resetFilters = async () => {
        setLoadshow("show-m");
        setOverlayBlock("show-m");

        try {
            setDate(latestDate);
            setWarehouse({ label: "ALL", value: "" });
            await getWarehouseOptionsByDate(latestDate);
            await loadDataForDate(latestDate, "");
        } catch (error) {
            console.error("Error resetting filters:", error);
            setBasicTitle("Failed to reset filters");
            setBasicType("error");
            setShow(true);
        } finally {
            setLoadshow("show-n");
            setOverlayBlock("show-n");
        }
    };

    const handleDateChange = async (selectedDate) => {
        const dateString = selectedDate ? new Date(selectedDate).toISOString().split('T')[0] : "";
        setDate(dateString);

        if (dateString) {
            await getWarehouseOptionsByDate(dateString);
        } else {
            setWarehouseOptions([{ label: "ALL", value: "" }]);
            setWarehouse({ label: "ALL", value: "" });
        }
    };

    // Download Excel Template
    const downloadExcelTemplate = () => {
        const sampleData = [
            ["warehouse_id", "warehouse_name", "sku_code", "type", "category", "sku_name", "sub_category", "bad_bin", "old_version", "qc_hold", "current_version"],
            ["WH001", "Main Warehouse", "SKU001", "PM", "Category A", "Sample SKU", "Sub Category A", "10", "5", "2", "100"]
        ];

        const ws = utils.aoa_to_sheet(sampleData);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, "WarehouseStockTemplate");
        writeFile(wb, "warehouse_stock_template.xlsx");
    };

    // Handle File Change
//    const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     setFile(e.target.value);
//     const filename = file.name;
//     setFilename(filename);

//     const reader = new FileReader();
//     reader.onload = (event) => {
//         try {
//             const data = new Uint8Array(event.target.result);
//             const workbook = XLSX.read(data, { type: "array" });

//             let worksheet = workbook.Sheets["Summary"];
//             if (!worksheet) {
//                 // If "Summary" sheet doesn't exist, try the first sheet
//                 worksheet = workbook.Sheets[workbook.SheetNames[0]];
//             }

//             let headers = [];
//             let result = [];

//             if (worksheet) {
//                 // Read all rows
//                 const allRows = XLSX.utils.sheet_to_json(worksheet, { header: 1, raw: false });

//                 if (allRows.length === 0) {
//                     console.error("Sheet is empty.");
//                     setShow(true);
//                     setBasicType("error");
//                     setBasicTitle("The uploaded file is empty.");
//                     return;
//                 }

//                 // 🔍 SMART HEADER DETECTION
//                 let headerRowIndex = -1;
                
//                 // Check different possible header row configurations
//                 const possibleHeaderRows = [0, 1]; // Row 0 and Row 1
                
//                 for (let rowIndex of possibleHeaderRows) {
//                     if (rowIndex < allRows.length) {
//                         const row = allRows[rowIndex];
//                         // Check if this row looks like headers (contains expected keywords)
//                         const headerKeywords = ['sku', 'product', 'batch', 'date', 'balance', 'qty', 'quantity', 'stock', 'dispatch', 'receipt'];
//                         const rowText = row.join(' ').toLowerCase();
//                         const keywordMatches = headerKeywords.filter(keyword => rowText.includes(keyword));
                        
//                         if (keywordMatches.length >= 2) { // At least 2 header keywords found
//                             headerRowIndex = rowIndex;
//                             console.log(`Found headers at row ${rowIndex} with keywords:`, keywordMatches);
//                             break;
//                         }
//                     }
//                 }

//                 // If no smart detection, use row 1 as default (like your original logic)
//                 if (headerRowIndex === -1 && allRows.length > 1) {
//                     headerRowIndex = 1;
//                     console.log("Using default header row 1");
//                 }

//                 if (headerRowIndex === -1) {
//                     console.error("Could not identify header row");
//                     setShow(true);
//                     setBasicType("error");
//                     setBasicTitle("Could not identify headers in the file. Please check the file format.");
//                     return;
//                 }

//                 const headerRow = allRows[headerRowIndex];
                
//                 // 🎯 FLEXIBLE HEADER PROCESSING
//                 headers = headerRow.map((header, idx) => {
//                     if (!header || header.toString().trim() === '') {
//                         return `column_${idx + 1}`; // Generate column name for empty headers
//                     }

//                     let headerText = header.toString().trim();
                    
//                     // Handle merged headers (row 0 + row 1 scenario)
//                     if (headerRowIndex === 1 && allRows.length > 0) {
//                         const upperHeader = allRows[0][idx];
//                         if (upperHeader && upperHeader.toString().trim() !== '') {
//                             // Skip if it's a fixed label like "CLS. BAL"
//                             const isFixedLabel = /cls\.?\s*bal/i.test(headerText.toLowerCase());
//                             if (!isFixedLabel) {
//                                 headerText = `${headerText}_${upperHeader}`;
//                             }
//                         }
//                     }

//                     // Clean and format header
//                     return headerText
//                         .replace(/\s+/g, "_")
//                         .replace(/[A-Z]/g, (letter) => letter.toLowerCase())
//                         .replace(/[^a-z0-9_\-]/g, "");
//                 });

//                 console.log("Processed headers:", headers);

//                 // 📊 DATA EXTRACTION
//                 // Start from the row after headers
//                 const dataStartRow = headerRowIndex + 1;
                
//                 result = allRows.slice(dataStartRow)
//                     .filter(row => {
//                         // Filter out empty rows
//                         return row.some(cell => cell !== undefined && cell !== null && cell.toString().trim() !== '');
//                     })
//                     .map(row => {
//                         const obj = {};
//                         headers.forEach((header, idx) => {
//                             const value = row[idx] ?? "";
//                             // Convert numeric strings to numbers if possible
//                             obj[header] = !isNaN(value) && value !== "" ? Number(value) : value;
//                         });
//                         return obj;
//                     });

//                 console.log("Parsed Data:", result);
                
//                 if (result.length === 0) {
//                     setShow(true);
//                     setBasicType("warning");
//                     setBasicTitle("No data found in the file after headers.");
//                     return;
//                 }

//                 setUploadedFileData(result);
//             } else {
//                 console.error("No worksheet found in the file");
//                 setShow(true);
//                 setBasicType("error");
//                 setBasicTitle("No valid worksheet found in the file.");
//             }

//         } catch (error) {
//             console.error("Error processing file:", error);
//             setShow(true);
//             setBasicType("error");
//             setBasicTitle("Error processing file. Please check the file format and try again.");
//         }
//     };
//     reader.onerror = () => {
//         setShow(true);
//         setBasicType("error");
//         setBasicTitle("Error reading file");
//     };
//     reader.readAsArrayBuffer(file);
// };

const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setFile(e.target.value);
    setFilename(file.name);

    const reader = new FileReader();

    reader.onload = (event) => {
        try {
            const data = new Uint8Array(event.target.result);
            const workbook = XLSX.read(data, { type: "array" });

            // Prefer "Summary" sheet, else first sheet
            let worksheet = workbook.Sheets["Summary"];
            if (!worksheet) worksheet = workbook.Sheets[workbook.SheetNames[0]];

            // Read rows exactly as in Excel (row-wise array)
            const allRows = XLSX.utils.sheet_to_json(worksheet, {
                header: 1,
                raw: false,
            });

            if (allRows.length < 2) {
                console.error("Invalid Excel: Needs at least 2 header rows.");
                return;
            }

            let finalOutput = [];

            const row0 = allRows[0]; // Upper header
            const row1 = allRows[1]; // Lower header
            const maxLength = Math.max(row0.length, row1.length);

            // ------------------------------------------------------
            // ⭐ 1) FIRST OBJECT = Merge Row0 keys + Row1 values
            // ------------------------------------------------------
            let headerObject = {};

            for (let i = 0; i < maxLength; i++) {
                let upperKey = row0[i];

                // If empty → generate Unnamed: X
                if (!upperKey || upperKey.toString().trim() === "") {
                    upperKey = `Unnamed: ${i}`;
                }

                // Lower row value may be empty string
                let lowerValue = row1[i] ?? "";

                headerObject[upperKey] = lowerValue;
            }

            finalOutput.push(headerObject);

            // ------------------------------------------------------
            // ⭐ 2) ALL OTHER ROWS = Push as objects (same keys as row0)
            // ------------------------------------------------------
            for (let r = 2; r < allRows.length; r++) {
                const row = allRows[r];

                // Skip empty rows
                if (!row || row.every(cell =>
                    cell === "" ||
                    cell === null ||
                    cell === undefined
                )) {
                    continue;
                }

                let rowObj = {};

                for (let c = 0; c < maxLength; c++) {
                    let upperKey = row0[c];

                    if (!upperKey || upperKey.toString().trim() === "") {
                        upperKey = `Unnamed: ${c}`;
                    }

                    rowObj[upperKey] = row[c] ?? "";
                }

                finalOutput.push(rowObj);
            }

            console.log("FINAL RAW JSON EXACT:", finalOutput);
            setUploadedFileData(finalOutput);

        } catch (err) {
            console.error("Excel parse error:", err);
        }
    };

    reader.readAsArrayBuffer(file);
};




    // Check if data exists
    const checkDataWithDateAndWarehouse = async () => {
        try {
            const response = await redirectURL.post(
                "inventory/checkWarehouseStockDataByDateAndWarehouse",
                {
                    date: uploadDate,
                    warehouse: uploadWarehouse?.value || ""
                }
            );
            
            return response?.data?.status === "success"
                ? response.data.exists
                : false;

        } catch (err) {
            console.error("Error checking data:", err);
            return false;
        }
    };

    const handleDataUpload = async (upload_type) => {
        const params = { 
            date: uploadDate, 
            warehouse: uploadWarehouse?.value || "",
            warehouse_name: uploadWarehouse?.label || "", 
            data: uploadedFileData, 
            filename,
            upload_type
        };

        console.log("Upload params:", params);

        try {
            setLoadshow("show-m");
            setOverlayBlock("show-m");
            
            const response = await redirectURL.post(
                "inventory/UploadPMWarehouseCurrentStock",
                params
            );

            const res = response?.data.pyResponse;

            if (res?.status === "Success") {
                await getWarehouseStockData();
                setLoadshow("show-n");
                setOverlayBlock("show-n");
                setShow(true);
                setBasicType("success");
                setBasicTitle(res.message);

                const userData = {
                    email: localStorage.getItem("email"),
                    user_code: localStorage.getItem("user_code"),
                    action: "Bulk Uploaded Warehouse Stock Data",
                    status: "Success",
                    path: window.location.pathname
                };
                triggerUserAction(userData);

                hideOverlySlideBlock();

            } else {
                setLoadshow("show-n");
                setOverlayBlock("show-n");
                setShow(true);
                setBasicType("info");
                setBasicTitle(res.message);

                const userData = {
                    email: localStorage.getItem("email"),
                    user_code: localStorage.getItem("user_code"),
                    action: "Bulk Uploaded Warehouse Stock Data",
                    status: "Failure",
                    path: window.location.pathname
                };
                triggerUserAction(userData);
            }

        } catch (error) {
            const errorMessage = error.response?.data?.message || "Failed to upload data";
            setShow(true);
            setBasicType("error");
            setBasicTitle(errorMessage);
            setLoadshow("show-n");
            setOverlayBlock("show-n");

            // User Action Triggering
            const userData = {
                email: localStorage.getItem("email"),
                user_code: localStorage.getItem("user_code"),
                action: "Bulk Uploaded Warehouse Stock Data",
                status: "Failure",
                path: window.location.pathname
            };
            triggerUserAction(userData);
        }
    };

    // Upload Submit Function
    const onClickingFileSubmit = async () => {
        if (uploadedFileData.length === 0) {
            setShow(true);
            setBasicType("info");
            setBasicTitle("Please upload a valid file");
            return;
        }

        if (!uploadWarehouse) {
            setShow(true);
            setBasicType("info");
            setBasicTitle("Please select a warehouse");
            return;
        }

        if (!uploadDate) {
            setShow(true);
            setBasicType("info");
            setBasicTitle("Please select a date");
            return;
        }

        // Check filename contains warehouse name
        // const firstWord = uploadWarehouse?.label?.split(" ")[0]?.toLowerCase();
        // console.log(firstWord,"firstWord")
        // const containsWord = filename.toLowerCase().includes(firstWord);
        // console.log(containsWord)
        // if (!containsWord) {
        //     setShow(true);
        //     setBasicType("info");
        //     setBasicTitle("Please upload a file with the correct name that matches the Warehouse name.");
        //     return;
        // }

        // const data_exists = await checkDataWithDateAndWarehouse();

        // if (data_exists) {
        //     setConfirmPopup(data_exists);
        //     return;
        // }

        handleDataUpload("new_upload");
    };

    // Upload Button Click
    const onClickUploadWarehouseStock = () => {
        setUploadedFileData([]);
        setUploadWarehouse(null);
        setUploadDate(todayIST());
        setFile(null);
        setFilename("");
        setSliderOpen(true);
        setSliderTitle("Upload Warehouse Stock Data");
        setOverlyBlock("show-m");
        
        getUploadWarehouseOptions();
    };

    // Hide Slider
    const hideOverlySlideBlock = () => {
        setOverlyBlock("show-n");
        setSliderOpen(false);
        if (document.getElementById("bulkUploadFile")) {
            document.getElementById("bulkUploadFile").value = "";
        }
        setUploadedFileData([]);
        setFile(null);
        setUploadWarehouse(null);
        setUploadDate(todayIST());
        setFilename("");
        setConfirmPopup(false);
    };

    // Close Slider Icon
    const onClickingSliderCloseIcon = () => {
        setOverlyBlock("show-n");
        setSliderOpen(false);
        if (document.getElementById("bulkUploadFile")) {
            document.getElementById("bulkUploadFile").value = "";
        }
        setUploadedFileData([]);
        setFile(null);
        setUploadWarehouse(null);
        setUploadDate(todayIST());
        setFilename("");
        setConfirmPopup(false);
    };

    // User Action Triggering
    const triggerUserAction = (trigerdata) => {
        redirectURL.post('inventory/triggerUserAction', trigerdata)
    };

    useEffect(() => {
        const getData = async () => {
            await getWarehouseStockData();
        };
        getData();
    }, []);

    const closeAlert = () => {
        setShow(false);
        setLoadshow("show-n");
        setOverlayBlock("show-n");
    };

    return (
        <>
            <div className="container-fluid mt-3">
                <div style={{ zIndex: "9999999" }}>
                    <SweetAlert
                        show={show}
                        type={basicType}
                        title={basicTitle}
                        onConfirm={closeAlert}
                        style={{ fontSize: "9px" }}
                    />
                </div>

                <div className="row" style={{ fontSize: "0.9rem", fontFamily: "Arial, sans-serif" }}>
                    
                    <form className="col-sm-12 p-0 mt-4 mb-4" style={{ display: "flex", alignItems: "center" }}>
                        <div className="col-sm-10 row">
                            {/* Date Filter */}
                            <div className="col-sm-3 mb-1" style={{ display: "flex", flexDirection: "column" }}>
                                <label style={{ fontSize: "13px", fontWeight: "400" }}>
                                    Date:
                                </label>
                                <DatePicker
                                    selected={date ? new Date(date) : null}
                                    onChange={handleDateChange}
                                    dateFormat="yyyy-MM-dd"
                                    className="form-control"
                                    placeholderText="Select Date"
                                    highlightDates={highlightedDates}
                                />
                            </div>

                            {/* Warehouse Filter */}
                            <div className="col-sm-3 mb-1" style={{ display: 'flex', flexDirection: 'column' }}>
                                <label htmlFor="warehouse" style={{ fontSize: '13px', fontWeight: '400' }}>
                                    Warehouse:
                                </label>
                                <Select
                                    id="warehouse"
                                    value={warehouse}
                                    onChange={(selectedOption) => setWarehouse(selectedOption)}
                                    options={warehouseOptions}
                                    styles={selectStyles}
                                    isDisabled={!date}
                                />
                            </div>

                            {/* Filter Buttons */}
                            <div className="ml-4 mt-4" style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "0px 10px" }}>
                                <button
                                    type="button"
                                    onClick={(e) => { e.preventDefault(); applyFilters(); }}
                                    style={{
                                        backgroundColor: "#93385D",
                                        color: "#fff",
                                        borderRadius: "5px",
                                        padding: "8px 20px",
                                        border: "none",
                                        cursor: "pointer"
                                    }}
                                >
                                    Apply
                                </button>
                                <button
                                    onClick={(e) => { e.preventDefault(); resetFilters(); }}
                                    type="button"
                                    style={{
                                        backgroundColor: "#fff",
                                        color: "#000",
                                        borderRadius: "5px",
                                        padding: "8px 20px",
                                        border: "1px solid #d9d9d9",
                                        cursor: "pointer"
                                    }}
                                >
                                    Reset
                                </button>
                            </div>
                        </div>

                        {/* Upload Button */}
                        <div className="col-sm-2 d-flex justify-content-end">
                            <button
                                type="button"
                                onClick={onClickUploadWarehouseStock}
                                className="mr-2"
                                style={{
                                    ...addButtonStyle,
                                    backgroundColor: "#F4EBEF",
                                    color: "#93385D",
                                    border: "2px solid #93385D",
                                }}
                            >
                                <MdOutlineFileUpload style={{ color: "#93385D", fontSize: "20px" }} />
                                &nbsp;
                                Upload Stock Data
                            </button>
                        </div>
                    </form>

                    {/* Data Grid */}
                    <div className="col-sm-12 p-0 pl-2 mt-6">
                        <div
                            className="ag-theme-alpine"
                            style={{
                                height: 'calc(100vh - 250px)',
                                width: "100%",
                                minHeight: '400px'
                            }}
                        >
                            <AgGridReact
                                rowData={filteredData}
                                columnDefs={columnWithDefs}
                                defaultColDef={defaultColDef}
                                domLayout="normal"
                                onGridReady={onGridReady}
                                sideBar={sideBar}
                                statusBar={statusPanel}
                                enableRangeSelection={true}
                                suppressColumnVirtualisation={true}
                                ensureDomOrder={true}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Upload Slider */}
            <div
                className={`stock-status-slider ${isSliderOpen ? "open" : ""} slider-25`}
                style={{ width: "25%" }}
            >
                <div className="slider-header-container d-flex justify-content-between">
                    <p className="m-0p">{sliderTitle}</p>
                    <p
                        className="m-0p"
                        style={{ cursor: "pointer" }}
                        onClick={onClickingSliderCloseIcon}
                    >
                        X&nbsp;&nbsp;&nbsp;
                    </p>
                </div>
                
                <div style={{ display: "flex", flexDirection: "column", height: "100%", overflowY: "auto", padding: 5 }}>
                    <div style={{ flexGrow: 1, overflowY: "auto", padding: "10px" }}>
                        {/* <div className="d-flex justify-content-end mb-10p">
                            <button
                                id="sample-download-button"
                                onClick={downloadExcelTemplate}
                                style={{
                                    padding: "8px 16px",
                                    backgroundColor: "#93385D",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                    fontSize: "0.8rem"
                                }}
                            >
                                {"Download Sample Template"}
                            </button>
                        </div> */}

                        {/* Warehouse Select for Upload */}
                        <div className="mb-1" style={{ display: 'flex', flexDirection: 'column' }}>
                            <label htmlFor="uploadWarehouse" style={{ fontSize: '13px', fontWeight: '400' }}>
                                Warehouse:
                            </label>
                            <Select
                                id="uploadWarehouse"
                                value={uploadWarehouse}
                                onChange={(selectedOption) => setUploadWarehouse(selectedOption)}
                                options={uploadWarehouseOptions}
                                styles={selectStyles}
                                placeholder="Select Warehouse"
                            />
                        </div>

                        {/* Date Select for Upload */}
                        <div className="mb-1" style={{ display: "flex", flexDirection: "column" }}>
                            <label style={{ fontSize: "13px", fontWeight: "400" }}>
                                Date:
                            </label>
                            <DatePicker
                                selected={uploadDate ? new Date(uploadDate) : null}
                                onChange={(date) => setUploadDate(date ? formatDateForInput(date) : '')}
                                dateFormat="yyyy-MM-dd"
                                className="form-control"
                                placeholderText="Select Date"
                                maxDate={new Date()}
                            />
                        </div>

                        {/* File Upload */}
                        <input
                            type="file"
                            accept=".csv,.xlsx,.xls"
                            onChange={handleFileChange}
                            style={{
                                border: "1px solid lightgrey",
                                width: "100%",
                                padding: "8px",
                                borderRadius: "5px",
                                backgroundColor: "#f9f9f9",
                                color: "#000",
                                fontSize: "13px",
                                marginTop: "10px"
                            }}
                            value={file}
                            id="bulkUploadFile"
                        />
                        <p style={{ color: "red", fontSize: "13px", margin: "0px", marginTop: "10px" }}>
                            *Accept .csv & .xlsx files only
                        </p>
                        <div style={{ textAlign: "right", marginTop: "10px" }}>
                            <button
                                style={{ 
                                    backgroundColor: (uploadedFileData.length > 0 && uploadWarehouse && uploadDate) ? "#93385D" : "#ccc", 
                                    color: "#fff", 
                                    fontSize: "0.8rem",
                                    padding: "8px 20px",
                                    border: "none",
                                    borderRadius: "5px",
                                    cursor: (uploadedFileData.length > 0 && uploadWarehouse && uploadDate) ? "pointer" : "not-allowed"
                                }}
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (uploadedFileData.length > 0 && uploadWarehouse && uploadDate) {
                                        onClickingFileSubmit();
                                    }
                                }}
                                disabled={!(uploadedFileData.length > 0 && uploadWarehouse && uploadDate)}
                            >
                                {"Submit"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Confirmation Popup */}
            {confirmPopup && (
                <div className="popup-overlay">
                    <div className="popup-box">
                        <h3>Data already exists</h3>
                        <p style={{ marginBottom: "20px", fontSize: "14px", color: "#555" }}>
                            Data for <b>{uploadDate}</b> and <b>{uploadWarehouse.label}</b> already exists.
                            Do you want to Re Upload the data ?
                        </p>
                        <div className="popup-actions">
                            <button
                                onClick={() => {
                                    setConfirmPopup(false);
                                    handleDataUpload("re_upload");
                                }}
                                className="yes-btn"
                            >
                                Yes
                            </button>
                            <button
                                onClick={() => setConfirmPopup(false)}
                                className="no-btn"
                            >
                                No
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
            <div className={`overlay-block ${overlayBlock}`}></div>
            <div
                className={"overly-block " + overlyBlock}
                onClick={hideOverlySlideBlock}
            ></div>
        </>
    );
};

// Styles
const selectStyles = {
    control: (base) => ({
        ...base,
        padding: '1px',
        borderRadius: '5px',
        border: '1px solid #d9d9d9',
        minHeight: '38px'
    }),
    singleValue: (base) => ({
        ...base,
        fontWeight: 'normal',
        color: '#333',
        fontSize: "12px"
    }),
    option: (base, state) => ({
        ...base,
        fontSize: "13px",
        fontWeight: state.isSelected ? 'normal' : 'normal',
    })
};

const addButtonStyle = {
    padding: "8px 20px",
    backgroundColor: "#93385D",
    color: "#fff",
    fontFamily: "sans-serif",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "0.8rem",
    fontWeight: "bold",
};

export default WarehouseStockStatus;